export default __webpack_public_path__ + "static/media/close.da29e40e.svg";